import PropTypes from 'prop-types';
import { renderValidatedEditorNode } from '../utilities/htmlEditorUtils.js';

const ViewItem = ({ item }) => renderValidatedEditorNode(item);

ViewItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ViewItem;
